import { fromJS } from 'immutable';
import {
  SET_CORPOREAL_ENCRYPTED_DOCUMENTS,
  SET_JUDGEMENT_ON_MERITS_BY_VEHICLES,
  SET_JUDGEMENT_ON_MERITS_BY_VICTIMS,
  SET_MATERIAL_ENCRYPTED_DOCUMENTS,
  SET_SAGIS_CLAIM,
  SET_ASSIGNED_LAWYERS,
  SET_REGULATIONS,
  RESET_SAGIS_CLAIM_INFO,
  SET_CREATED_REGULATIONS,
  SET_REGULATION,
} from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { RegulationProvisionReducer } from 'containers/LawyerLegalProceedingsPage/typings';
import { get } from 'lodash';

const initialState: any = fromJS({
  sagisClaim: {},
  judgementOnMeritsByVictims: [],
  judgementOnMeritsByVehicles: [],
  corporealEncryptedDocuments: [],
  materialEncryptedDocuments: [],
  assignedLawyers: [],
  regulations: [],
  createdRegulations: [],
  currentRegulation: {},
});
const ProvisionRegulationReducer = (
  state = initialState,
  action: RegulationProvisionReducer,
) => {
  switch (action.type) {
    case SET_SAGIS_CLAIM:
      return state.set('sagisClaim', fromJS(action.sagisClaim.data));
    case SET_JUDGEMENT_ON_MERITS_BY_VICTIMS: {
      return state.set(
        'judgementOnMeritsByVictims',
        fromJS(action.judgementOnMeritsByVictims),
      );
    }
    case SET_JUDGEMENT_ON_MERITS_BY_VEHICLES: {
      return state.set(
        'judgementOnMeritsByVehicles',
        fromJS(action.judgementOnMeritsByVehicles),
      );
    }
    case SET_CORPOREAL_ENCRYPTED_DOCUMENTS: {
      return state.set(
        'corporealEncryptedDocuments',
        fromJS(get(action, 'corporealEncryptedDocuments', [])),
      );
    }
    case SET_MATERIAL_ENCRYPTED_DOCUMENTS: {
      return state.set(
        'materialEncryptedDocuments',
        fromJS(get(action, 'materialEncryptedDocuments', [])),
      );
    }
    case SET_ASSIGNED_LAWYERS: {
      return state.set(
        'assignedLawyers',
        fromJS(get(action, 'assignedLawyers', [])),
      );
    }
    case SET_REGULATIONS: {
      return state.set('regulations', fromJS(get(action, 'regulations', [])));
    }
    case SET_CREATED_REGULATIONS: {
      return state.set(
        'createdRegulations',
        fromJS(get(action, 'createdRegulations', [])),
      );
    }
    case SET_REGULATION: {
      return state.set(
        'currentRegulation',
        fromJS(get(action, 'regulation', {})),
      );
    }
    case RESET_SAGIS_CLAIM_INFO:
      return initialState;
    default:
      return state;
  }
};

export default ProvisionRegulationReducer;
